'use strict';

var implementation$1 = require('./implementation.js');

var implementation = implementation$1;

var polyfill = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};

module.exports = polyfill;
